import FileUpload from "react-material-file-upload";
import PropTypes from "prop-types";
import { imageUpload } from "Apis/signIn";
import { useEffect, useState } from "react";
import colors from "assets/theme/base/colors";
import MDBox from "components/MDBox";

export default function MDDropzone(props) {
  const [uploadedFile, setUploadedFile] = useState([]);
  const [errors, setErrors] = useState("");
  const maxSizeInMB = 5;
  const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
  const { imageUploader, info, sideNav, error } = colors;

  const handleImageChange = async (e) => {
    const file = e[0];

    if (file) {
      if (file.size > maxSizeInBytes) {
        setErrors(`File can't be larger than 5 MB`);
        return;
      }

      setErrors("");
      setUploadedFile(e);
      const formData = new FormData();
      formData.append("folderName", props?.folderName);
      formData.append("file", file);

      let fileUploadResponse = await imageUpload(formData);
      if (fileUploadResponse?.status === 200) {
        const uploadedImageName = fileUploadResponse?.data.data[0].name;
        props?.formik.setFieldValue(props?.fileName, uploadedImageName);
      }
    }

    if (e.length === 0) {
      setUploadedFile(null);
      props?.formik.setFieldValue(props?.fileName, null);
    }
  };

  useEffect(() => {
    if (props?.value?.length > 0) {
      setUploadedFile(props?.value);
    }
  }, [props?.value]);

  return (
    <div
      className="cc-upload__file"
      style={{
        textAlign: "center",
        border: "none",
        borderRadius: "10px",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          border: `2px dashed ${info.main}`,
          borderRadius: "10px",
        }}
      >
        <FileUpload
          value={uploadedFile}
          name={props?.name}
          onChange={handleImageChange}
          multiple={props?.multiple}
          maxFileSize={maxSizeInBytes}
          maxUploadFiles={props?.maxUploadFiles}
          accept={props?.accept}
          onBlur={props?.onBlur}
          title="Drag 'n' drop file here, or click to select file"
          sx={{ border: "none", marginTop: "1px" }}
        />
        <MDBox sx={{ fontSize: "14px", marginBottom: "20px" }}>
          File can't be larger than 5 MB
        </MDBox>
      </div>
      {errors && (
        <div
          style={{
            color: "red",
            marginTop: "10px",
            fontSize: "12px",
            display: "flex",
            alignItems: "start",
          }}
        >
          {errors}
        </div>
      )}
    </div>
  );
}

MDDropzone.propTypes = {
  value: PropTypes.any.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  maxFileSize: PropTypes.number,
  maxUploadFiles: PropTypes.number,
  accept: PropTypes.string,
  onBlur: PropTypes.func,
};
